/**
 * noc-scroll-props.js
 * Expose Lenis scroll state as CSS custom properties on :root
 * --scroll       : 0→1 normalized page progress
 * --scroll-v     : velocity magnitude 0→1 (clamped)
 * --scroll-dir   : 1 (down) | -1 (up)
 * --scroll-px    : raw pixel position
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var ticking = false;
  var last = 0;

  function update(scroll, velocity, direction) {
    var max = document.body.scrollHeight - window.innerHeight;
    var progress = max > 0 ? Math.min(1, Math.max(0, scroll / max)) : 0;
    var vel = Math.min(1, Math.abs(velocity || 0));

    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.style.setProperty('--scroll',    progress.toFixed(4));
      root.style.setProperty('--scroll-v',  vel.toFixed(3));
      root.style.setProperty('--scroll-dir', direction >= 0 ? '1' : '-1');
      root.style.setProperty('--scroll-px', Math.round(scroll) + 'px');
      ticking = false;
    });
  }

  /* Wait for Lenis to be instantiated */
  function attach() {
    if (window.__lenis) {
      window.__lenis.on('scroll', function (e) {
        update(e.scroll, e.velocity, e.direction);
      });
      return;
    }
    /* Fallback: native scroll */
    window.addEventListener('scroll', function () {
      var now = window.scrollY;
      var dir = now > last ? 1 : -1;
      last = now;
      update(now, 0, dir);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach, { once: true });
  } else {
    attach();
  }
}());
